import { render, staticRenderFns } from "./detailRecord.vue?vue&type=template&id=307afd1a&"
import script from "./detailRecord.vue?vue&type=script&lang=js&"
export * from "./detailRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports